import { useAtomValue } from 'jotai';
import { useCompanyType } from '../hooks/useCompanyType';
import { selectedCompanyIdProfileAtom } from '../../CompanyProfiles/state/UIStateJ';
import { CompanyType } from '../../../data-models/company.data-model';
import { useShowSummaryV2 } from './useShowSummaryV2';
import { CompanySummaryPortfolio } from './CompanySummaryPortfolio';
import { CompanySummaryPortfolioV2 } from './CompanySummaryPortfolioV2';
import { CompanySummaryDiscovery } from './CompanySummaryDiscovery';
import { CompanySummaryDiscoveryV2 } from './CompanySummaryDiscoveryV2';

export function CompanySummary2() {
  const showSummaryV2 = useShowSummaryV2();
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);
  const companyType = useCompanyType(companyId);

  // The two layouts differ structurally — a 340px Digest rail plus one stack of sections, versus
  // the paired-area grid — so the flag picks a whole layout rather than being threaded through one.
  // Cards whose only difference is their container resolve the flag in `SummarySection`.
  const portfolio = showSummaryV2 ? <CompanySummaryPortfolioV2 /> : <CompanySummaryPortfolio />;
  const discovery = showSummaryV2 ? <CompanySummaryDiscoveryV2 /> : <CompanySummaryDiscovery />;

  switch (companyType) {
    case undefined:
      return null;
    case CompanyType.portfolio:
      return portfolio;
    case CompanyType.discovery:
    case CompanyType.passed:
      return discovery;
    default:
      return discovery;
  }
}
